export class DeliveryItem {
    article: string;
    name: string;
    unitName: string = "шт";
    price: number = 0;
    quantity: number;
    constructor(obj: Partial<DeliveryItem>) {
		Object.assign(this, obj);
	}
}